export default {
  home: {
    title: 'USFans Spreadsheet : trouvez, comparez et explorez les ressources USFans',
    metaDescription: 'Explorez les ressources USFans Spreadsheet, les catégories de produits, les guides d’achat, les informations de livraison et les conseils de sécurité, dans un hub multilingue facile à utiliser.',
    hero: {
      badge: 'Centre de ressources indépendant',
      h1: 'USFans Spreadsheet : trouvez, comparez et explorez les ressources USFans',
      subtitle: 'Explorez les dernières ressources USFans Spreadsheet, les guides produits, les conseils d’achat, les informations de livraison et les ressources de sécurité, le tout organisé dans un hub unique et facile à utiliser.',
      trust1: 'Ressources organisées',
      trust2: 'Mises à jour régulières',
      trust3: 'Guides multilingues',
      trust4: 'Informations de sécurité',
      dropdownLabel: 'Choisissez une catégorie',
      dropdownPlaceholder: 'Sélectionnez une catégorie de produit',
    },
    why: {
      title: 'Pourquoi utiliser USFans Spreadsheet ?',
      text: 'Trouver des ressources USFans utiles peut être difficile lorsque l’information est dispersée sur différents sites, communautés et publications. Notre objectif est d’organiser les informations les plus utiles de USFans Spreadsheet en catégories claires, guides pratiques et comparaisons faciles à comprendre.',
    },
    categories: {
      title: 'Parcourez les catégories de produits',
      subtitle: 'Accédez directement à la catégorie souhaitée sur le site principal.',
      viewAll: 'Voir toutes les catégories',
    },
    topics: {
      title: 'Sujets USFans populaires',
      subtitle: 'Les sujets les plus recherchés.',
      topic1Title: 'USFans Spreadsheet',
      topic1Desc: 'La vue d’ensemble complète de la feuille, des catégories et des liens.',
      topic2Title: 'Avis USFans',
      topic2Desc: 'Ce qu’il faut savoir avant d’utiliser USFans, avec avantages et inconvénients.',
      topic3Title: 'Frais de livraison USFans',
      topic3Desc: 'Comprenez les tarifs, les délais et comment économiser.',
      topic4Title: 'Coupon USFans',
      topic4Desc: 'Comment trouver les coupons et offres de réduction actuels.',
      topic5Title: 'Code promo USFans',
      topic5Desc: 'Un aperçu pratique de l’endroit où apparaissent les codes promo.',
      topic6Title: 'Entrepôt USFans',
      topic6Desc: 'Comment fonctionnent l’entrepôt, le stockage et le contrôle qualité.',
      topic7Title: 'USFans est-il fiable ?',
      topic7Desc: 'Vérifications de sécurité et ce qu’il faut contrôler avant d’acheter.',
    },
    guides: {
      title: 'Derniers guides',
      subtitle: 'Des articles originaux et détaillés pour tirer le meilleur parti de USFans Spreadsheet.',
      readMore: 'Lire le guide',
      articleTitle: 'Qu’est-ce que USFans Spreadsheet ? Un guide complet',
      articleCategory: 'Guide',
      articleReadingTime: '6 min de lecture',
      articleSummary: 'Un aperçu clair et original du fonctionnement de USFans Spreadsheet, de la navigation dans les catégories, de la comparaison des produits et de l’achat en toute confiance.',
    },
    pillars: {
      title: 'Articles piliers',
      subtitle: 'Des guides détaillés sur les sujets les plus importants, mis à jour régulièrement.',
      label: 'Guide',
      minRead: 'min de lecture',
      readMore: 'Lire le guide',
      items: {
        spreadsheetGuide: { title: 'Qu’est-ce que USFans Spreadsheet ?', summary: 'Un aperçu clair de ce qu’est la feuille et de son organisation.' },
        howToUse: { title: 'Comment utiliser USFans Spreadsheet', summary: 'Des conseils pas à pas pour parcourir les catégories et trouver des produits rapidement.' },
        directory: { title: 'Répertoire USFans Spreadsheet', summary: 'Comment le répertoire regroupe les produits et les liens pour une navigation plus facile.' },
        review: { title: 'Avis USFans : avantages et inconvénients', summary: 'Un regard équilibré sur les points forts et les points de vigilance.' },
        shippingCost: { title: 'Guide des frais de livraison USFans', summary: 'Comprenez les tarifs, les délais et les moyens concrets d’économiser.' },
        warehouse: { title: 'Guide de l’entrepôt USFans', summary: 'Comment fonctionnent le stockage, le contrôle qualité et l’expédition.' },
        coupon: { title: 'Guide des coupons et codes USFans', summary: 'Où trouver les coupons et codes promo actuels.' },
        legit: { title: 'USFans est-il fiable ?', summary: 'Les vérifications de sécurité et ce qu’il faut contrôler avant d’acheter.' },
        buyingGuide: { title: 'Guide d’achat USFans', summary: 'Une liste pratique pour un achat fluide et éclairé.' },
        safety: { title: 'Guide de sécurité USFans', summary: 'Comment vérifier les liens, les paiements et rester en sécurité en ligne.' },
      },
    },
    safety: {
      title: 'Utilisez les ressources USFans en toute sécurité',
      text: 'Vérifiez toujours les liens, les prix actuels, les informations de livraison et les coordonnées du vendeur avant d’acheter. Ne partagez jamais vos mots de passe, codes d’authentification ou données de paiement sensibles avec des sites inconnus.',
      cta: 'Lire le guide de sécurité',
      check1: 'Vérifiez le domaine',
      check2: 'Contrôlez HTTPS',
      check3: 'Ne partagez jamais vos mots de passe',
      check4: 'Ne partagez jamais vos codes de vérification',
    },
    faq: {
      title: 'Questions fréquentes',
      subtitle: 'Des réponses rapides aux questions courantes sur USFans Spreadsheet.',
      q1: 'Qu’est-ce que USFans Spreadsheet ?',
      a1: 'USFans Spreadsheet est une liste organisée de produits de mode et streetwear américains et de liens d’achat, regroupée en catégories claires comme les chaussures, les hoodies, les t-shirts et les accessoires pour trouver plus vite ce dont vous avez besoin.',
      q2: 'USFans Spreadsheet est-il gratuit ?',
      a2: 'La consultation des catégories et des guides est gratuite. Vérifiez toujours les prix actuels, les détails de livraison et les informations du vendeur sur le site principal avant d’acheter.',
      q3: 'Comment trouver un produit précis ?',
      a3: 'Utilisez le menu déroulant des catégories ou les boutons de catégories de cette page pour accéder directement à la section correspondante du site principal.',
      q4: 'USFans est-il fiable ?',
      a4: 'Nous recommandons toujours de vérifier les liens, de contrôler HTTPS et de confirmer vous-même les coordonnées du vendeur et du paiement avant d’acheter. Traitez tout site inconnu avec prudence.',
      q5: 'Que dois-je vérifier avant d’acheter ?',
      a5: 'Vérifiez les prix actuels, les frais et délais de livraison, les politiques de retour et les coordonnées du vendeur. Les informations peuvent changer, alors confirmez les derniers détails sur le site principal.',
      q6: 'À quelle fréquence les informations sont-elles mises à jour ?',
      a6: 'Nous nous efforçons de maintenir les guides et catégories à jour, mais confirmez toujours les offres et prix actuels sur le site principal avant d’acheter.',
    },
    final: {
      title: 'Prêt à explorer les ressources USFans Spreadsheet ?',
      text: 'Commencez par le hub USFans Spreadsheet et découvrez des guides, comparaisons, avis, informations de livraison et ressources pratiques.',
    },
  },
};